module.exports = __webpack_public_path__ + "static/media/vii-ambientworks.2126395.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/vii-ambientworks.mp3
// module id = lEyA
// module chunks = 0